import { useContext } from "react";
import { Grid, Box } from '@mui/material';
import UserContext from "Context/UserProvider";

import { isAgreeProduct, isPlanProduct, isShareProduct } from "utils/productUtils";
import { isBusinessRole } from "utils/roleUtils";
import Bookings from "./business/Bookings";
import ChargingSessions from "./business/ChargingSessions";
import PartnerChargingNetwork from "./business/PartnerChargingNetwork";
import ChargingSummaryBarChart from "./business/savings/ChargingSummaryBarChart";
import ChargingSummaryPieChart from "./business/savings/ChargingSummaryPieChart";
import Billing from "./common/Billing";
import News from "./common/News";
import UserManagement from "./common/UserManagement";
import GettingStarted from "./account/GettingStarted";


type BusinessDashboardProps = {
    dashboardInfo: any;
};

function BusinessDashboard({ dashboardInfo }: BusinessDashboardProps) {
    const { userInfo, selectedProduct } = useContext(UserContext);
    const isBusinessOnly = isBusinessRole(userInfo.userType);
    const inboundTitle = "Recent Inbound Charging Sessions";

    if (!isBusinessOnly) {
        return null;
    }

    if (selectedProduct !== null && isAgreeProduct(selectedProduct)) {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}><News /></Grid>
                <Grid item xs={12}><Billing /></Grid>
            </Grid>
        );
    }

    if (selectedProduct !== null && isPlanProduct(selectedProduct)) {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}><News /></Grid>
                <Grid item xs={12}><Billing /></Grid>
            </Grid>
        );
    }

    if (selectedProduct !== null && isShareProduct(selectedProduct)) {

        console.log("BD + " + JSON.stringify(dashboardInfo.inboundChargingSessions));

        return (
            <Grid 
                container 
                spacing={3}
                sx={{ 
                    m: 0,
                    mt: -3,
                    ml: -3,
                    width: 'calc(100% + 24px)'
                }}
            >
                <Grid item xs={12}>
                    <GettingStarted onboardingProgress={dashboardInfo.onboardingProgress} />
                </Grid>
                <Grid item xs={12}>
                    <UserManagement dashboardInfo={dashboardInfo} />
                </Grid>
                <Grid item xs={12}>
                    <PartnerChargingNetwork dashboardInfo={dashboardInfo} />
                </Grid>
                <Grid item xs={12}>
                    <Bookings dashboardInfo={dashboardInfo} />
                </Grid>
                <Grid item xs={12}>
                    <ChargingSessions 
                        title={inboundTitle} 
                        chargingSessions={dashboardInfo.inboundChargingSessions} 
                        incomeCostTitle="Income" 
                    />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                    <ChargingSummaryBarChart
                        fleetScenarioUuid=""
                        data={[
                            { name: "Partner Charging Cost", price: Math.round(dashboardInfo.currentMonth?.partnerChargingCost) },
                            { name: "Est. Public Charging Cost", price: Math.round(dashboardInfo.currentMonth?.publicChargingCost) },
                        ]}
                        dashboardInfo={dashboardInfo}
                    />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                    <ChargingSummaryPieChart
                        total={dashboardInfo.countChargePointsUsedByYourBusiness + "/" + dashboardInfo.countChargePointsInNetwork}
                        unit={"Charge Points"}
                        fleetScenarioUuid={""}
                        fleetScenarioNumber={""}
                        title={"Percentage of Network Charge Points used"}
                        height={400}
                        width={400}
                        data={dashboardInfo.outboundChargePointUsage}
                    />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                    <ChargingSummaryPieChart
                        total={dashboardInfo.countBusinessesServedByYourChargePoints + "/" + dashboardInfo.businessesInPCN}
                        unit={"Businesses"}
                        fleetScenarioUuid={""}
                        fleetScenarioNumber={""}
                        title={"Percentage of Businesses using your charge points"}
                        height={400}
                        width={400}
                        data={dashboardInfo.inboundBusinessUsage}
                    />
                </Grid>
            </Grid>
        );
    }

    return null;
}

export default BusinessDashboard;
